"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QRPReportConfirmEvent = exports.QRPReportCompletedEvent = exports.IssueThumbnailRetakeAnalyticsEvent = exports.IssueThumbnailOpenFromActivityLogAnalyticsEvent = exports.IssueThumbnailOpenAnalyticsEvent = exports.IssueThumbnailAnnotateClickAnalyticsEvent = exports.IssueStatusSettingDeactivateAnalyticsEvent = exports.IssueStatusSettingActivateAnalyticsEvent = exports.IssueSortApplyAnalyticEvent = exports.IssueSnapshotStatusAnalyticsEvent = exports.IssueSnapshotNavigateAwayAnalyticsEvent = exports.IssueSnapshotCreateTrigger = exports.IssueSnapshotCreateAnalyticsEvent = exports.IssueSettingTypeEditAnalyticsEvent = exports.IssueSettingTypeDeleteClickAnalyticsEvent = exports.IssueSettingTypeDeleteAnalyticsEvent = exports.IssueSettingTypeCreateEditFieldAnalyticsEvent = exports.IssueSettingTypeCreateCancelConfirmationAnalyticsEvent = exports.IssueSettingTypeCreateCancelAnalyticsEvent = exports.IssueSettingTypeCreateAnalyticsEvent = exports.IssueSettingTypeCategoryEditAnalyticsEvent = exports.IssueSettingTypeCategoryDeleteClickAnalyticsEvent = exports.IssueSettingTypeCategoryDeleteAnalyticsEvent = exports.IssueSettingTypeCategoryCreateEditFieldAnalyticsEvent = exports.IssueSettingTypeCategoryCreateCancelConfirmationAnalyticsEvent = exports.IssueSettingTypeCategoryCreateCancelAnalyticsEvent = exports.IssueSettingTypeCategoryCreateAnalyticsEvent = exports.IssueSettingTemplateEditAnalyticsEvent = exports.IssueSettingTemplateDuplicateClickAnalyticsEvent = exports.IssueSettingTemplateDeleteClickAnalyticsEvent = exports.IssueSettingTemplateDeleteAnalyticsEvent = exports.IssueSettingTemplateCreateClickAnalyticsEvent = exports.IssueSettingTemplateCreateCancelAnalyticsEvent = exports.IssueSettingTemplateCreateAnalyticsEvent = exports.IssueSettingTabsClickAnalyticsEvent = exports.IssueSettingRootCauseEditAnalyticsEvent = exports.IssueSettingRootCauseDeleteClickAnalyticsEvent = exports.IssueSettingRootCauseDeleteAnalyticsEvent = exports.IssueSettingRootCauseCreateAnalyticsEvent = exports.IssueSettingRootCauseCategoryEditAnalyticsEvent = exports.IssueSettingRootCauseCategoryDeleteClickAnalyticsEvent = exports.IssueSettingRootCauseCategoryDeleteAnalyticsEvent = exports.IssueSettingRootCauseCategoryCreateAnalyticsEvent = exports.IssueSettingPermissionLearnMoreExitAnalyticsEvent = exports.IssueSettingPermissionLearnMoreClickAnalyticsEvent = exports.IssueSettingPermissionFilterSuccessAnalyticsEvent = exports.IssueSettingPermissionFilterOpenAnalyticsEvent = exports.IssueSettingPermissionEditDropdownAnalyticsEvent = exports.IssueSettingPermissionEditAnalyticsEvent = exports.IssueSettingPermissionDeleteClickAnalyticsEvent = exports.IssueSettingPermissionDeleteAnalyticsEvent = exports.IssueSettingPermissionCreateAnalyticsEvent = exports.IssueSettingPageViewAnalyticsEvent = exports.IssueSettingItemClickAnalyticsEvent = exports.IssueSettingCustomFieldEditAnalyticsEvent = exports.IssueSettingCustomFieldDeleteClickAnalyticsEvent = exports.IssueSettingCustomFieldDeleteAnalyticsEvent = exports.IssueSettingCustomFieldCreateAnalyticsEvent = exports.IssueSettingCreateOptionsClickAnalyticsEvent = exports.IssueSettingCreateClickAnalyticsEvent = exports.IssueSearchOpenAnalyticEvent = exports.IssueSearchClickAnalyticsEvent = exports.IssueRestoreButtonConfirmAnalyticEvent = exports.IssueRestoreButtonClickAnalyticEvent = exports.IssueRestoreButtonCancelAnalyticEvent = exports.IssueRemoveIssueAnnotationSuccessAnalyticsEvent = exports.IssueReferenceRemoveAnalyticsEvent = exports.IssueReferenceAddAnalyticsEvent = exports.IssueLogViewAnalyticsEvent = exports.IssueLogSettingMenuClickAnalyticsEvent = exports.IssueLogSettingClickAnalyticsEvent = exports.IssueLogPaginationAnalyticsEvent = exports.IssueFilterOpenAnalyticsEvent = exports.IssueFilterApplyAnalyticsEvent = exports.IssueExportShareAnalyticsEvent = exports.IssueExportConfirmAnalyticsEvent = exports.IssueEditSaveAnalyticsEvent = exports.IssueDrawerViewAnalyticsEvent = exports.IssueDeleteConfirmAnalyticsEvent = exports.IssueDeleteClickAnalyticsEvent = exports.IssueDeleteCancelAnalyticsEvent = exports.IssueCreateSuccessAnalyticsEvent = exports.IssueCreateMarkupTypeSearchAnalyticsEvent = exports.IssueCreateMarkupTypeClickAnalyticsEvent = exports.IssueCreateMarkupTypeClearSearchAnalyticsEvent = exports.IssueCreateMarkupClickAnalyticsEvent = exports.IssueCreateEditFieldAnalyticsEvent = exports.IssueCreateClickAnalyticsEvent = exports.IssueCreateCancelConfirmationAnalyticsEvent = exports.IssueCreateCancelAnalyticsEvent = exports.IssueAttachmentRemoveAnalyticsEvent = exports.IssueAttachmentClickAnalyticsEvent = exports.IssueAttachmentAddAnalyticsEvent = exports.IssueAddCommentsAnalyticsEvent = exports.BcfExportCompletedAnalyticsEvent = exports.BASE_ISSUE_ATTRIBUTE_TO_ANALYTICS_FIELD = void 0;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * This is a copy of analytics-lib at version 0.0.93
 *
 * @plangrid-private cannot be accessed by some consumers of alloy,
 * and acc-issues is included in alloy, and analytics-lib is part of @plangrid-private.
 *
 * So we temporarily include the exports we need in our own library, so we can remove the dependency.
 *
 *
 */

const createAnalyticsEvent = name => {
  return class {
    constructor() {
      _defineProperty(this, "name", name);
      _defineProperty(this, "parameters", {
        analyticsLib: "0.0.93"
      });
    }
  };
};
const IssueCreateClickAnalyticsEvent = exports.IssueCreateClickAnalyticsEvent = createAnalyticsEvent("issue.create.click");
const IssueCreateMarkupClickAnalyticsEvent = exports.IssueCreateMarkupClickAnalyticsEvent = createAnalyticsEvent("issue.create.markup.click");
const IssueCreateMarkupTypeClickAnalyticsEvent = exports.IssueCreateMarkupTypeClickAnalyticsEvent = createAnalyticsEvent("issue.create.markup.type.click");
const IssueCreateMarkupTypeSearchAnalyticsEvent = exports.IssueCreateMarkupTypeSearchAnalyticsEvent = createAnalyticsEvent("issue.create.markup.type.search");
const IssueCreateMarkupTypeClearSearchAnalyticsEvent = exports.IssueCreateMarkupTypeClearSearchAnalyticsEvent = createAnalyticsEvent("issue.create.markup.type.clear.search");
class IssueCreateSuccessAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.create.success");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.issue_uid = params.issueUid;
    this.parameters.display_id = params.displayId;
    this.parameters.placement = params.placement;
    this.parameters.linkedDocuments = params.linkedDocuments;
    this.parameters.document_file_type = params.documentFileType;
    this.parameters.is_published = params.isPublished;
    this.parameters.reference_picker = params.referencePicker;
    this.parameters.title = params.title;
    this.parameters.status = params.status;
    this.parameters.type = params.type;
    this.parameters.category = params.category;
    this.parameters.description = params.description;
    this.parameters.assignee = params.assignee;
    this.parameters.watchers = params.watchers;
    this.parameters.start_date = params.startDate;
    this.parameters.due_date = params.dueDate;
    this.parameters.location = params.location;
    this.parameters.location_details = params.locationDetails;
    this.parameters.root_cause = params.rootCause;
    this.parameters.dropdown = params.dropdown;
    this.parameters.numeric = params.numeric;
    this.parameters.paragraph = params.paragraph;
    this.parameters.text = params.text;
    this.parameters.origin = params.origin;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueCreateSuccessAnalyticsEvent = IssueCreateSuccessAnalyticsEvent;
const IssueCreateCancelAnalyticsEvent = exports.IssueCreateCancelAnalyticsEvent = createAnalyticsEvent("issue.create.cancel");

//currently not being used since it reqires some modification to the CreationModal
class IssueCreateCancelConfirmationAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.create.cancel.confirmation");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.issue_create_cancel_confirmation_action = params.issue_create_cancel_confirmation_action;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueCreateCancelConfirmationAnalyticsEvent = IssueCreateCancelConfirmationAnalyticsEvent;
const IssueDeleteClickAnalyticsEvent = exports.IssueDeleteClickAnalyticsEvent = createAnalyticsEvent("issue.delete.click");
class IssueDeleteConfirmAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.delete.confirm");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.issue_uid = params.issueUid;
    this.parameters.comment = params.comment;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueDeleteConfirmAnalyticsEvent = IssueDeleteConfirmAnalyticsEvent;
class IssueDeleteCancelAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.delete.cancel");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {
      ...params
    };
  }
}
exports.IssueDeleteCancelAnalyticsEvent = IssueDeleteCancelAnalyticsEvent;
class IssueCreateEditFieldAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.create.edit.field");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.field_type = params.field_type;
  }
}
exports.IssueCreateEditFieldAnalyticsEvent = IssueCreateEditFieldAnalyticsEvent;
const IssueLogSettingClickAnalyticsEvent = exports.IssueLogSettingClickAnalyticsEvent = createAnalyticsEvent("issue.log.setting.click");
class IssueLogSettingMenuClickAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.log.setting.menu.click");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.issue_setting_dropdown_option_click = params.issue_setting_dropdown_option_click;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueLogSettingMenuClickAnalyticsEvent = IssueLogSettingMenuClickAnalyticsEvent;
class IssueSettingTabsClickAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.tabs.click");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.issue_setting_tabs_click = params.issue_setting_tabs_click;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingTabsClickAnalyticsEvent = IssueSettingTabsClickAnalyticsEvent;
class IssueSettingCreateClickAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.create.click");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.source = params.source;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingCreateClickAnalyticsEvent = IssueSettingCreateClickAnalyticsEvent;
class IssueSettingItemClickAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.item.click");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.issue_setting_item_click = params.issue_setting_item_click;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingItemClickAnalyticsEvent = IssueSettingItemClickAnalyticsEvent;
class IssueSettingCreateOptionsClickAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.create.options.click");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.issue_setting_create_dropdown_option_click = params.issue_setting_create_dropdown_option_click;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingCreateOptionsClickAnalyticsEvent = IssueSettingCreateOptionsClickAnalyticsEvent;
class IssueSettingPageViewAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.page.view");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.page_type = params.pageType;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingPageViewAnalyticsEvent = IssueSettingPageViewAnalyticsEvent;
class IssueSettingTypeCreateAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.type.create");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.type_uid = params.typeUid;
    this.parameters.title = params.title;
    this.parameters.category = params.category;
    this.parameters.status = params.status;
    this.parameters.pin_label = params.pinLabel;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingTypeCreateAnalyticsEvent = IssueSettingTypeCreateAnalyticsEvent;
class IssueSettingTypeCreateEditFieldAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.type.create.edit.field");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.field_type = params.field_type;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingTypeCreateEditFieldAnalyticsEvent = IssueSettingTypeCreateEditFieldAnalyticsEvent;
class IssueSettingTypeEditAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.type.edit");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.type_uid = params.typeUid;
    this.parameters.category = params.category;
    this.parameters.edited_title = params.editedTitle;
    this.parameters.edited_status = params.editedStatus;
    this.parameters.edited_pin_label = params.editedPinLabel;
    this.parameters.editedCustomFields = params.editedCustomFields;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingTypeEditAnalyticsEvent = IssueSettingTypeEditAnalyticsEvent;
class IssueSettingTypeDeleteClickAnalyticsEvent {
  constructor() {
    _defineProperty(this, "name", "issue.setting.type.delete.click");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingTypeDeleteClickAnalyticsEvent = IssueSettingTypeDeleteClickAnalyticsEvent;
class IssueSettingTypeDeleteAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.type.delete");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.type_uid = params.typeUid;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingTypeDeleteAnalyticsEvent = IssueSettingTypeDeleteAnalyticsEvent;
class IssueSettingTypeCategoryCreateAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.type_category.create");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.category_uid = params.categoryUid;
    this.parameters.title = params.title;
    this.parameters.issue_types_count = params.issueTypesCount;
    this.parameters.status = params.status;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingTypeCategoryCreateAnalyticsEvent = IssueSettingTypeCategoryCreateAnalyticsEvent;
class IssueSettingTypeCategoryCreateEditFieldAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.type.category.create.edit.field");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.field_type = params.field_type;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingTypeCategoryCreateEditFieldAnalyticsEvent = IssueSettingTypeCategoryCreateEditFieldAnalyticsEvent;
const IssueSettingTypeCreateCancelAnalyticsEvent = exports.IssueSettingTypeCreateCancelAnalyticsEvent = createAnalyticsEvent("issue.setting.type.create.cancel");
class IssueSettingTypeCreateCancelConfirmationAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.type.create.cancel.confirmation");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.issue_create_cancel_confirmation_action = params.issue_create_cancel_confirmation_action;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingTypeCreateCancelConfirmationAnalyticsEvent = IssueSettingTypeCreateCancelConfirmationAnalyticsEvent;
const IssueSettingTypeCategoryCreateCancelAnalyticsEvent = exports.IssueSettingTypeCategoryCreateCancelAnalyticsEvent = createAnalyticsEvent("issue.setting.type.category.create.cancel");
class IssueSettingTypeCategoryCreateCancelConfirmationAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.type.category.create.cancel.confirmation");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.issue_create_cancel_confirmation_action = params.issue_create_cancel_confirmation_action;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingTypeCategoryCreateCancelConfirmationAnalyticsEvent = IssueSettingTypeCategoryCreateCancelConfirmationAnalyticsEvent;
class IssueSettingTypeCategoryEditAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.type_category.edit");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.category_uid = params.categoryUid;
    this.parameters.edited_title = params.editedTitle;
    this.parameters.edited_status = params.editedStatus;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingTypeCategoryEditAnalyticsEvent = IssueSettingTypeCategoryEditAnalyticsEvent;
const IssueSettingTypeCategoryDeleteClickAnalyticsEvent = exports.IssueSettingTypeCategoryDeleteClickAnalyticsEvent = createAnalyticsEvent("issue.setting.type_category.delete.click");
class IssueSettingTypeCategoryDeleteAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.type_category.delete");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.category_uid = params.categoryUid;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingTypeCategoryDeleteAnalyticsEvent = IssueSettingTypeCategoryDeleteAnalyticsEvent;
class IssueSettingRootCauseCategoryCreateAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.root_cause_category.create");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.root_cause_category_uid = params.rootCauseCategoryUid;
    this.parameters.title = params.title;
    this.parameters.root_causes_count = params.rootCausesCount;
    this.parameters.status = params.status;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingRootCauseCategoryCreateAnalyticsEvent = IssueSettingRootCauseCategoryCreateAnalyticsEvent;
class IssueSettingRootCauseCategoryEditAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.root_cause_category.edit");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.root_cause_category_uid = params.rootCauseCategoryUid;
    this.parameters.edited_title = params.editedTitle;
    this.parameters.edited_status = params.editedStatus;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingRootCauseCategoryEditAnalyticsEvent = IssueSettingRootCauseCategoryEditAnalyticsEvent;
const IssueSettingRootCauseCategoryDeleteClickAnalyticsEvent = exports.IssueSettingRootCauseCategoryDeleteClickAnalyticsEvent = createAnalyticsEvent("issue.setting.root_cause_category.delete.click");
class IssueSettingRootCauseCategoryDeleteAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.root_cause_category.delete");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.root_cause_category_uid = params.rootCauseCategoryUid;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingRootCauseCategoryDeleteAnalyticsEvent = IssueSettingRootCauseCategoryDeleteAnalyticsEvent;
class IssueSettingRootCauseCreateAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.root_cause.create");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.root_cause_uid = params.rootCauseUid;
    this.parameters.rc_category_name = params.rcCategoryName;
    this.parameters.title = params.title;
    this.parameters.status = params.status;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingRootCauseCreateAnalyticsEvent = IssueSettingRootCauseCreateAnalyticsEvent;
class IssueSettingRootCauseEditAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.root_cause.edit");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.root_cause_uid = params.rootCauseUid;
    this.parameters.rc_category_name = params.rcCategoryName;
    this.parameters.edited_title = params.editedTitle;
    this.parameters.edited_status = params.editedStatus;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingRootCauseEditAnalyticsEvent = IssueSettingRootCauseEditAnalyticsEvent;
const IssueSettingRootCauseDeleteClickAnalyticsEvent = exports.IssueSettingRootCauseDeleteClickAnalyticsEvent = createAnalyticsEvent("issue.setting.root_cause.delete.click");
class IssueSettingRootCauseDeleteAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.root_cause.delete");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.root_cause_uid = params.rootCauseUid;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingRootCauseDeleteAnalyticsEvent = IssueSettingRootCauseDeleteAnalyticsEvent;
class IssueSettingPermissionCreateAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.permission.create");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.type = params.type;
    this.parameters.permission_level = params.permissionLevel;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingPermissionCreateAnalyticsEvent = IssueSettingPermissionCreateAnalyticsEvent;
class IssueSettingPermissionEditAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.permission.edit");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.type = params.type;
    this.parameters.new_permission_level = params.newPermissionLevel;
    this.parameters.old_permission_level = params.oldPermissionLevel;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingPermissionEditAnalyticsEvent = IssueSettingPermissionEditAnalyticsEvent;
class IssueSettingPermissionDeleteAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.permission.delete");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.type = params.type;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingPermissionDeleteAnalyticsEvent = IssueSettingPermissionDeleteAnalyticsEvent;
const IssueSettingPermissionLearnMoreClickAnalyticsEvent = exports.IssueSettingPermissionLearnMoreClickAnalyticsEvent = createAnalyticsEvent("issue.setting.permission.learn_more.click");
const IssueSettingPermissionLearnMoreExitAnalyticsEvent = exports.IssueSettingPermissionLearnMoreExitAnalyticsEvent = createAnalyticsEvent("issue.setting.permission.learn_more.exit");
const IssueSettingPermissionEditDropdownAnalyticsEvent = exports.IssueSettingPermissionEditDropdownAnalyticsEvent = createAnalyticsEvent("issue.setting.permission.edit.dropdown");
const IssueSettingPermissionDeleteClickAnalyticsEvent = exports.IssueSettingPermissionDeleteClickAnalyticsEvent = createAnalyticsEvent("issue.setting.permission.delete.click");
const IssueSettingPermissionFilterOpenAnalyticsEvent = exports.IssueSettingPermissionFilterOpenAnalyticsEvent = createAnalyticsEvent("issue.setting.permission.filter.open");
class IssueSettingPermissionFilterSuccessAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.permission.filter.success");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.contributor_type = params.contributor_type;
    this.parameters.permissions_level = params.permissions_level;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingPermissionFilterSuccessAnalyticsEvent = IssueSettingPermissionFilterSuccessAnalyticsEvent;
class IssueSettingCustomFieldCreateAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.custom_field.create");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.custom_field_uuid = params.customFieldUuid;
    this.parameters.description = params.description;
    this.parameters.title = params.title;
    this.parameters.field_type = params.fieldType;
    this.parameters.dropdown_option_count = params.dropdownOptionCount;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingCustomFieldCreateAnalyticsEvent = IssueSettingCustomFieldCreateAnalyticsEvent;
class IssueSettingCustomFieldEditAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.custom_field.edit");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.custom_field_uuid = params.customFieldUuid;
    this.parameters.field_type = params.fieldType;
    this.parameters.attribute_name = params.attributeName;
    this.parameters.old_attribute_value = params.oldAttributeValue;
    this.parameters.edited_attribute_value = params.editedAttributeValue;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingCustomFieldEditAnalyticsEvent = IssueSettingCustomFieldEditAnalyticsEvent;
const IssueSettingCustomFieldDeleteClickAnalyticsEvent = exports.IssueSettingCustomFieldDeleteClickAnalyticsEvent = createAnalyticsEvent("issue.setting.custom_field.delete.click");
class IssueSettingCustomFieldDeleteAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.custom_field.delete");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.custom_field_uuid = params.customFieldUuid;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingCustomFieldDeleteAnalyticsEvent = IssueSettingCustomFieldDeleteAnalyticsEvent;
class IssueDrawerViewAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.drawer.view");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.issue_uid = params.issueUid;
    this.parameters.deleted = params.deleted;
  }
}
exports.IssueDrawerViewAnalyticsEvent = IssueDrawerViewAnalyticsEvent;
class IssueEditSaveAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.edit.save");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.issue_uid = params.issueUid;
    this.parameters.field = params.field;
    this.parameters.custom_field_name = params.customFieldName;
    this.parameters.watcher_ct = params.watcherCt;
    this.parameters.old_field_value = params.oldFieldValue;
    this.parameters.edited_field_value = params.editedFieldValue;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueEditSaveAnalyticsEvent = IssueEditSaveAnalyticsEvent;
class IssueExportConfirmAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.export.confirm");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.export_type = params.exportType;
    this.parameters.file_format = params.fileFormat;
    this.parameters.filters = params.filters;
    this.parameters.issue_count = params.issueCount;
    this.parameters.is_export_all = params.isExportAll;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueExportConfirmAnalyticsEvent = IssueExportConfirmAnalyticsEvent;
class IssueExportShareAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.export.share");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.method_type = params.methodType;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueExportShareAnalyticsEvent = IssueExportShareAnalyticsEvent;
class BcfExportCompletedAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.export.completed");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.export_type = params.type;
    this.parameters.file_format = params.fileFormat;
    this.parameters.issue_count = params.issueCount;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.BcfExportCompletedAnalyticsEvent = BcfExportCompletedAnalyticsEvent;
class IssueFilterApplyAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.filter.apply");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.field = params.field;
    this.parameters.field_value = params.fieldValue;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueFilterApplyAnalyticsEvent = IssueFilterApplyAnalyticsEvent;
class IssueSearchClickAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.search.click");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.text = params.text;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSearchClickAnalyticsEvent = IssueSearchClickAnalyticsEvent;
const IssueSearchOpenAnalyticEvent = exports.IssueSearchOpenAnalyticEvent = createAnalyticsEvent("issue.search.open");
const IssueRestoreButtonClickAnalyticEvent = exports.IssueRestoreButtonClickAnalyticEvent = createAnalyticsEvent("issue.restore.click");
const IssueRestoreButtonCancelAnalyticEvent = exports.IssueRestoreButtonCancelAnalyticEvent = createAnalyticsEvent("issue.restore.cancel");
const IssueRestoreButtonConfirmAnalyticEvent = exports.IssueRestoreButtonConfirmAnalyticEvent = createAnalyticsEvent("issue.restore.confirm");
class IssueReferenceAddAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.reference.add");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.issue_uid = params.issueUid;
    this.parameters.object_uid = params.objectUid;
    this.parameters.object_type = params.objectType;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueReferenceAddAnalyticsEvent = IssueReferenceAddAnalyticsEvent;
class IssueReferenceRemoveAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.reference.remove");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.issue_uid = params.issueUid;
    this.parameters.object_uid = params.objectUid;
    this.parameters.object_type = params.objectType;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueReferenceRemoveAnalyticsEvent = IssueReferenceRemoveAnalyticsEvent;
class IssueAttachmentAddAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.attachment.add");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.attachment_file_type = params.attachmentFileType;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueAttachmentAddAnalyticsEvent = IssueAttachmentAddAnalyticsEvent;
class IssueAttachmentRemoveAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.attachment.remove");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.attachment_file_type = params.attachmentFileType;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueAttachmentRemoveAnalyticsEvent = IssueAttachmentRemoveAnalyticsEvent;
class IssueAttachmentClickAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.attachment.click");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.attachment_file_type = params.attachmentFileType;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueAttachmentClickAnalyticsEvent = IssueAttachmentClickAnalyticsEvent;
class IssueSortApplyAnalyticEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.sort.apply");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.sort_by = params.sortBy;
    this.parameters.order = params.order;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSortApplyAnalyticEvent = IssueSortApplyAnalyticEvent;
const IssueFilterOpenAnalyticsEvent = exports.IssueFilterOpenAnalyticsEvent = createAnalyticsEvent("issue.filter.open");
class IssueLogViewAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.log.view");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.deleted = params.isDeletedLog;
  }
}
exports.IssueLogViewAnalyticsEvent = IssueLogViewAnalyticsEvent;
class IssueLogPaginationAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.log.pagination");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.action = params.action;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueLogPaginationAnalyticsEvent = IssueLogPaginationAnalyticsEvent;
class IssueAddCommentsAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.add.comments");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.issue_add_comments_characters = params.commentCharacters;
    this.parameters.number_of_mentions = params.numberOfMentions;
    this.parameters.number_of_members = params.numOfUsers;
    this.parameters.number_of_roles = params.numOfRoles;
    this.parameters.number_of_companies = params.numOfCompanies;
    this.parameters.aggregated_mentionees = params.numOfAggregatedMentionees;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueAddCommentsAnalyticsEvent = IssueAddCommentsAnalyticsEvent;
const IssueThumbnailOpenAnalyticsEvent = exports.IssueThumbnailOpenAnalyticsEvent = createAnalyticsEvent("issue.thumbnail.open");
const IssueThumbnailOpenFromActivityLogAnalyticsEvent = exports.IssueThumbnailOpenFromActivityLogAnalyticsEvent = createAnalyticsEvent("issue.activity.thumbnail.open");
class IssueThumbnailRetakeAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.thumbnail.retake");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.keep_old_thumbnail = params.keepOldThumbnail;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueThumbnailRetakeAnalyticsEvent = IssueThumbnailRetakeAnalyticsEvent;
class IssueThumbnailAnnotateClickAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.thumbnail.annotate.click");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.issue_id = params.issueId;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueThumbnailAnnotateClickAnalyticsEvent = IssueThumbnailAnnotateClickAnalyticsEvent;
const IssueSnapshotNavigateAwayAnalyticsEvent = exports.IssueSnapshotNavigateAwayAnalyticsEvent = createAnalyticsEvent("issue.snapshot.navigate_away");
let IssueSnapshotCreateTrigger = exports.IssueSnapshotCreateTrigger = /*#__PURE__*/function (IssueSnapshotCreateTrigger) {
  IssueSnapshotCreateTrigger["SAVE_MARKUP_BUTTON"] = "save_markup_button";
  IssueSnapshotCreateTrigger["MOVE_ISSUE"] = "move_issue";
  IssueSnapshotCreateTrigger["CREATE_ISSUE"] = "create_issue";
  IssueSnapshotCreateTrigger["LINK_ISSUE"] = "link_issue";
  IssueSnapshotCreateTrigger["RETAKE_THUMBNAIL_BUTTON"] = "retake_thumbnail_button";
  IssueSnapshotCreateTrigger["EMPTY_STATE_BUTTON"] = "empty_state_button";
  IssueSnapshotCreateTrigger["SET_THUMBNAIL_BUTTON"] = "set_thumbnail_button";
  return IssueSnapshotCreateTrigger;
}({});
class IssueSnapshotCreateAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.snapshot.create");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.issue_id = params.issueId;
    this.parameters.trigger = params.trigger;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSnapshotCreateAnalyticsEvent = IssueSnapshotCreateAnalyticsEvent;
class IssueSnapshotStatusAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.snapshot.status");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.issue_id = params.issueId;
    this.parameters.has_markups = params.hasMarkups;
    this.parameters.hres = params.hres;
    this.parameters.vres = params.vres;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSnapshotStatusAnalyticsEvent = IssueSnapshotStatusAnalyticsEvent;
class IssueRemoveIssueAnnotationSuccessAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.remove.issue_annotation.success");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.issue_uid = params.issue_uid;
    this.parameters.sheet_uid = params.sheet_uid;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueRemoveIssueAnnotationSuccessAnalyticsEvent = IssueRemoveIssueAnnotationSuccessAnalyticsEvent;
const IssueSettingTemplateCreateClickAnalyticsEvent = exports.IssueSettingTemplateCreateClickAnalyticsEvent = createAnalyticsEvent("issue.setting.template.create.click");
class IssueSettingTemplateCreateAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.template.create");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters;
    this.parameters.id = params.id;
    this.parameters.is_active = params.isActive;
    this.parameters.status = params.status;
    this.parameters.root_cause_id = params.rootCauseId;
    this.parameters.location_id = params.locationId;
    this.parameters.watchers = params.watchers;
    this.parameters.assignee_id = params.assigneeId;
    this.parameters.assigned_to_type = params.assignedToType;
    this.parameters.days_til_due_date = params.daysTilDueDate;
    this.parameters.days_til_start_date = params.daysTilStartDate;
    this.parameters.type_id = params.typeId;
    this.parameters.category_id = params.categoryId;
    this.parameters.custom_attributes = params.customAttributes;
    this.parameters.creation_origin = params.creationOrigin;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingTemplateCreateAnalyticsEvent = IssueSettingTemplateCreateAnalyticsEvent;
class IssueSettingTemplateCreateCancelAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.template.create.cancel");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters;
    this.parameters.creation_origin = params.creationOrigin;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingTemplateCreateCancelAnalyticsEvent = IssueSettingTemplateCreateCancelAnalyticsEvent;
class IssueSettingTemplateEditAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.setting.template.edit");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters;
    this.parameters.edited_attribute = params.editedAttribute;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingTemplateEditAnalyticsEvent = IssueSettingTemplateEditAnalyticsEvent;
const IssueSettingTemplateDeleteClickAnalyticsEvent = exports.IssueSettingTemplateDeleteClickAnalyticsEvent = createAnalyticsEvent("issue.setting.template.delete.click");
class IssueSettingTemplateDeleteAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", void 0);
    _defineProperty(this, "parameters", void 0);
    this.name = params.eventName;
    this.parameters = {};
    this.parameters;
    this.parameters.template_id = params.templateId;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueSettingTemplateDeleteAnalyticsEvent = IssueSettingTemplateDeleteAnalyticsEvent;
const IssueSettingTemplateDuplicateClickAnalyticsEvent = exports.IssueSettingTemplateDuplicateClickAnalyticsEvent = createAnalyticsEvent("issue.setting.template.duplicate.click");
/** watchers aren't included in this object because it has two properties (watcher_added, watcher_removed) that can be tracked */
const BASE_ISSUE_ATTRIBUTE_TO_ANALYTICS_FIELD = exports.BASE_ISSUE_ATTRIBUTE_TO_ANALYTICS_FIELD = {
  title: "title",
  description: "description",
  status: "status",
  assignedTo: "assignee",
  startDate: "start_date",
  dueDate: "due_date",
  locationDetails: "location_details",
  locationId: "location",
  issueTypeId: "type",
  rootCauseId: "root_cause",
  published: "is_published",
  placement: "placement"
};
class IssueStatusSettingActivateAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.status.activate");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.status = params.statusName;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueStatusSettingActivateAnalyticsEvent = IssueStatusSettingActivateAnalyticsEvent;
class IssueStatusSettingDeactivateAnalyticsEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.status.deactivate");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.status = params.statusName;
    this.parameters["analyticsLib"] = "0.0.93";
  }
}
exports.IssueStatusSettingDeactivateAnalyticsEvent = IssueStatusSettingDeactivateAnalyticsEvent;
class QRPReportConfirmEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.export.confirm");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.deleted = params.isIssueDeleted;
  }
}
exports.QRPReportConfirmEvent = QRPReportConfirmEvent;
class QRPReportCompletedEvent {
  constructor(params) {
    _defineProperty(this, "name", "issue.export.completed");
    _defineProperty(this, "parameters", void 0);
    this.parameters = {};
    this.parameters.deleted = params.isIssueDeleted;
  }
}
exports.QRPReportCompletedEvent = QRPReportCompletedEvent;
//# sourceMappingURL=analyticsLib093IssuesEvents.js.map